import { GRPopoverState, UPDATE_POPOVER_ID } from '../reducers/GRPopoverReducer'

export const updateOpeningPopoverId = (payload: GRPopoverState) => {
  return {
    type: UPDATE_POPOVER_ID,
    payload,
  }
}
